import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO + JSON-LD wrapper.
 * Pass `title`, `description`, optional `path` (for canonical) and optional `jsonLd` object.
 */
export default function SEO({ title, description, path = "/", jsonLd, image }) {
    const fullTitle = title?.includes("alva digital") ? title : `${title} — alva digital`;
    const url = `https://alvadigital.fr${path}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="fr_FR" />
            {image && <meta property="og:image" content={image} />}
            <meta name="twitter:card" content="summary_large_image" />
            <html lang="fr" />
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
